// FILE: assets/partify-cro.js
// Partify CRO — auto-selections, price deltas, sticky ATC

(function () {
	"use strict";

	// ─── CONSTANTS ─────────────────────────────────────────────────────────────
	const QUALITY_RADIO_SEL = 'input[name="quality_type"]';
	const PAINT_RADIO_SEL = 'input[name="select_paint_option"]';
	const UNPAINTED_ID = "checkbox-select-unpainted";
	const STORED_PAINT_ID = "checkbox-paint-code-local-storage";
	const STORED_PAINT_LABEL = "paint-code-stored-option";
	const ASSEMBLY_NO_SEL = 'input[name="bundle_mode"][value="single"]';
	const BUNDLE_CONTAINER_ID = "bundle-options";
	const MAIN_ATC_SEL = ".add-to-cart";
	const FITMENT_RADIO_SEL = ".fitment-radio";
	const LS_KEY = "searchTerms";
	const VIN_SENTINEL = ".VIN";
	const BUMPERDOTCOM_MAKE_FALLBACK =
		"toyota,lexus,scion,lincoln,ford,bmw,acura,honda,mercedes,mercury,mitsubishi,volvo,volkswagen";

	// ─── Submodel → paint code defaults ───────────────────────────────────────
	// To add a new submodel: push one entry. Zero logic changes required.
	const SUBMODEL_PAINT_DEFAULTS = [{ match: /ZR2/i, paintCode: "8555" }];

	// ─── Helpers ───────────────────────────────────────────────────────────────

	function formatDelta(delta) {
		if (delta === 0) return "";
		const str = Math.abs(delta).toFixed(2);
		return (delta > 0 ? "+" : "-") + "$" + str;
	}

	function normalizeMakeToken(value) {
		return String(value || "")
			.toLowerCase()
			.replace(/[^a-z0-9]/g, "");
	}

	function makeListContains(list, make) {
		const target = normalizeMakeToken(make);
		if (!target) return false;
		return String(list || "")
			.split(",")
			.map(normalizeMakeToken)
			.some(function (item) {
				return (
					item &&
					(item === target ||
						target.indexOf(item) !== -1 ||
						item.indexOf(target) !== -1)
				);
			});
	}

	function truthyFlag(value) {
		return (
			value === true ||
			value === 1 ||
			String(value || "")
				.trim()
				.toLowerCase() === "true" ||
			String(value || "").trim() === "1"
		);
	}

	function isMatchByVinCode(value) {
		const raw = String(value || "").trim();
		const upper = raw.toUpperCase();
		return (
			upper === VIN_SENTINEL ||
			upper === "VIN" ||
			/match\s+(paint\s+)?by\s+vin/i.test(raw)
		);
	}

	function shouldForceMatchByVin(vehicle) {
		if (!vehicle) return false;
		const make = vehicle.make || vehicle.ymm || vehicle.vehicle || "";
		const vin = String(vehicle.vin || "")
			.trim()
			.toUpperCase();
		return !!(
			makeListContains(window.BUMPERDOTCOM_MAKES_LIST || BUMPERDOTCOM_MAKE_FALLBACK, make) &&
			(vin.length === 17 ||
				String(vehicle.plate || vehicle.licensePlate || "").trim() ||
				truthyFlag(vehicle.decodedByBumper))
		);
	}

	function getSavedPaintCode() {
		try {
			const terms = JSON.parse(localStorage.getItem(LS_KEY)) || [];
			if (!terms.length) return null;
			if (shouldForceMatchByVin(terms[0])) return "Match Paint by VIN";
			const code = terms[0].paintCode;
			if (!code || isMatchByVinCode(code) || code === "") return null;
			return code;
		} catch (e) {
			return null;
		}
	}

	function getVehicleSubmodel() {
		try {
			const terms = JSON.parse(localStorage.getItem(LS_KEY) || "[]");
			const vehicle = terms[0] || {};
			const ymm = (vehicle.ymm || "").toString();
			const submodel = (vehicle.submodel || "").toString();
			return ymm + " " + submodel;
		} catch (e) {
			return "";
		}
	}

	function getSelectedQualityLabel() {
		const checked = document.querySelector(QUALITY_RADIO_SEL + ":checked");
		if (!checked) return "";
		const val = checked.value || "";
		if (val.includes("capa")) return "CAPA";
		if (val.includes("oem")) return "OEM";
		return "Aftermarket";
	}

	function getSelectedPaintLabel() {
		const checked = document.querySelector(PAINT_RADIO_SEL + ":checked");
		if (!checked) return "";
		if (checked.id === UNPAINTED_ID) return "Unpainted";
		const label = checked.closest("label");
		if (!label) return "Painted";
		const text = label.textContent.trim().replace(/\s+/g, " ");
		// Trim to just the paint name, e.g. "Painted PGU" from "Painted PGU +$147.64"
		return text.replace(/\s*[+\-]\$[\d,.]+$/, "").trim() || "Painted";
	}

	function getSelectedAssemblyLabel() {
		const radio = document.querySelector('input[name="bundle_mode"]:checked');
		if (!radio) return "";
		return radio.value === "kit" ? "Assembly" : "No Assembly";
	}

	// ─── FEATURE 1: Auto-select cheapest quality (tier order breaks ties) ───

	function pickPreferredQuality(enabled) {
		const priority = ["aftermarket", "capa", "oem"];
		const normalizeQuality = function (value) {
			const normalized = String(value || "").toLowerCase();
			if (normalized.includes("aftermarket")) return "aftermarket";
			if (normalized.includes("capa")) return "capa";
			if (normalized.includes("oem")) return "oem";
			return normalized;
		};
		const prioritizedEnabled = priority
			.map(function (quality) {
				return enabled.find(function (radio) {
					return normalizeQuality(radio.value) === quality;
				});
			})
			.filter(Boolean);
		const basePrice = function (radio) {
			const price = Number.parseFloat((radio.dataset.price || "").replace(/,/g, ""));
			return Number.isFinite(price) ? price : Infinity;
		};

		return prioritizedEnabled.reduce(function (cheapest, radio) {
			return basePrice(radio) < basePrice(cheapest) ? radio : cheapest;
		}, prioritizedEnabled[0] || enabled[0]);
	}

	function autoSelectQuality() {
		if (window.__defaultConfigTestQuality) return;
		const radios = document.querySelectorAll(QUALITY_RADIO_SEL);
		if (!radios.length) return;
		// Don't override if one is already checked
		const alreadyChecked = Array.from(radios).some(function (r) {
			return r.checked && !r.disabled && r.dataset.available !== "false";
		});
		if (alreadyChecked) return;

		const enabled = Array.from(radios).filter(function (r) {
			return !r.disabled;
		});

		if (enabled.length) {
			const pick = pickPreferredQuality(enabled);
			if (pick) {
				pick.click();
				return;
			}
		}

		// All radios disabled (fitment questions gate them) — watch for enable
		const container = document.getElementById("quality-type-select");
		if (!container) return;
		const obs = new MutationObserver(function () {
			const nowEnabled = Array.from(
				document.querySelectorAll(QUALITY_RADIO_SEL),
			).filter(function (r) {
				return !r.disabled;
			});
			if (!nowEnabled.length) return;
			const nowChecked = nowEnabled.some(function (r) {
				return r.checked && r.dataset.available !== "false";
			});
			if (nowChecked) {
				obs.disconnect();
				return;
			}
			const pick = pickPreferredQuality(nowEnabled);
			if (pick) {
				obs.disconnect();
				pick.click();
				applyQualityDeltas();
			}
		});
		obs.observe(container, {
			subtree: true,
			attributes: true,
			attributeFilter: ["disabled"],
		});
		setTimeout(function () {
			obs.disconnect();
		}, 20000);
	}

	// ─── FEATURE 1B: Force cheapest quality on fitment/side changes ───────────

	function forceSelectPreferredQuality() {
		const radios = document.querySelectorAll(QUALITY_RADIO_SEL);
		if (!radios.length) return;
		const available = Array.from(radios).filter(function (r) {
			return !r.disabled && r.dataset.available !== "false";
		});
		if (!available.length) return;
		const currentChecked = document.querySelector(
			QUALITY_RADIO_SEL + ":checked",
		);
		if (
			currentChecked &&
			!currentChecked.disabled &&
			currentChecked.dataset.available !== "false"
		)
			return;

		const preferred = pickPreferredQuality(available);
		if (!preferred.checked) {
			preferred.checked = true;
			preferred.dispatchEvent(new Event("change", { bubbles: true }));
		}
	}

	// ─── FEATURE 2: Auto-select paint ─────────────────────────────────────────

	function autoSelectPaint() {
		if (window.__paintDefaultTestPainted) return;
		if (_zr2AutoSelectDone) return;
		const paintRadios = document.querySelectorAll(PAINT_RADIO_SEL);
		// If a paint radio is already checked (by global-library.js), don't override
		const alreadyChecked = Array.from(paintRadios).some(function (r) {
			return r.checked;
		});
		if (alreadyChecked) return;

		const savedPaint = getSavedPaintCode();

		if (savedPaint) {
			// The stored paint code radio is shown + populated by handleInsertLocalStoragePaintOption()
			// in global-library.js. If it's visible, click it.
			const storedLabel = document.getElementById(STORED_PAINT_LABEL);
			const storedRadio = document.getElementById(STORED_PAINT_ID);

			if (
				storedLabel &&
				storedRadio &&
				storedLabel.style.display !== "none" &&
				!storedRadio.disabled
			) {
				storedRadio.click();
				console.log("[Partify] Auto-selected paint: stored code");
				return;
			}

			// If stored radio isn't visible yet, wait for it
			if (storedLabel) {
				const obs = new MutationObserver(function () {
					if (storedLabel.style.display !== "none" && !storedRadio.disabled) {
						obs.disconnect();
						// Re-check that nothing was selected while we waited
						const nowChecked = Array.from(
							document.querySelectorAll(PAINT_RADIO_SEL),
						).some(function (r) {
							return r.checked;
						});
						if (!nowChecked) {
							storedRadio.click();
							console.log(
								"[Partify] Auto-selected paint: stored code (deferred)",
							);
						}
					}
				});
				obs.observe(storedLabel, {
					attributes: true,
					attributeFilter: ["style"],
				});
				// Timeout: stop waiting after 8s
				setTimeout(function () {
					obs.disconnect();
				}, 8000);
				return;
			}
		}

		// No saved paint code → select Unpainted
		const unpainted = document.getElementById(UNPAINTED_ID);
		if (unpainted && !unpainted.disabled) {
			unpainted.click();
			console.log("[Partify] Auto-selected paint: unpainted");
		} else if (unpainted) {
			// Unpainted is disabled — wait for it to become enabled
			const obs2 = new MutationObserver(function () {
				if (!unpainted.disabled) {
					obs2.disconnect();
					const nowChecked = Array.from(
						document.querySelectorAll(PAINT_RADIO_SEL),
					).some(function (r) {
						return r.checked;
					});
					if (!nowChecked) {
						unpainted.click();
						console.log("[Partify] Auto-selected paint: unpainted (deferred)");
					}
				}
			});
			obs2.observe(unpainted, {
				attributes: true,
				attributeFilter: ["disabled"],
			});
			setTimeout(function () {
				obs2.disconnect();
			}, 8000);
		}
	}

	// ─── FEATURE 3: Auto-select assembly "No" ─────────────────────────────────

	// ─── FEATURE ZR2: Auto-select paint code for ZR2 submodel ────────────────

	let _zr2AutoSelectDone = false;

	function autoSelectZR2Paint() {
		if (_zr2AutoSelectDone) return;

		const ymm = getVehicleSubmodel();
		const entry = SUBMODEL_PAINT_DEFAULTS.find(function (e) {
			return e.match.test(ymm);
		});
		if (!entry) return;

		const sel = document.getElementById("variant-selector");
		if (!sel) return;

		// Match by variantTitle data attribute, fallback to textContent starts-with
		const target = Array.from(sel.options).find(function (opt) {
			const vt = (opt.dataset.variantTitle || "").trim();
			return (
				vt === entry.paintCode ||
				opt.textContent.trim().startsWith(entry.paintCode)
			);
		});
		if (!target) return;

		_zr2AutoSelectDone = true;
		window._zr2AutoSelectDone = true;
		console.log(
			"[Partify] Submodel match (" +
				ymm +
				") — auto-selecting paint code " +
				entry.paintCode,
		);

		// Click the "Select Paint Code" radio to reveal the dropdown via its change handler
		const paintRadio = document.getElementById("checkbox-select-paint-option");
		if (paintRadio && !paintRadio.checked) {
			paintRadio.checked = true;
			paintRadio.dispatchEvent(new Event("change", { bubbles: true }));
		}

		// Now set the dropdown to the target paint code
		sel.value = target.value;
		const evt = new Event("change", { bubbles: true });
		evt._fromAutoSelect = true;
		sel.dispatchEvent(evt);
	}

	window.autoSelectZR2Paint = autoSelectZR2Paint;

	function autoSelectAssembly() {
		const bundleDiv = document.getElementById(BUNDLE_CONTAINER_ID);
		if (!bundleDiv) return;

		function maybeClickNo() {
			if (bundleDiv.style.display === "none") return;
			const noRadio = document.querySelector(ASSEMBLY_NO_SEL);
			if (noRadio && !noRadio.checked) {
				if (document.querySelector('input[name="bundle_mode"]:checked')) return;
				noRadio.click();
			}
		}

		// Check immediately and watch persistently — handles initial load,
		// vehicle changes, and cache-hit re-inits (all call syncBundleVisibility
		// which mutates style, triggering this observer each time)
		maybeClickNo();
		new MutationObserver(function () {
			maybeClickNo();
		}).observe(bundleDiv, {
			attributes: true,
			attributeFilter: ["style"],
		});
	}

	// ─── FEATURE 5: Auto-select body type from VIN decode ─────────────────────

	function autoSelectBodyType() {
		try {
			const terms = JSON.parse(localStorage.getItem(LS_KEY) || "[]");
			const decodedBodyTypes = Array.isArray(terms[0]?.decodedBodyTypes)
				? Array.from(new Set(terms[0].decodedBodyTypes.map(function (value) {
						return String(value || "").trim();
					}).filter(Boolean)))
				: [];
			if (decodedBodyTypes.length) {
				const validator = window.PartifyVinBodyTypeAcq;
				if (validator && typeof validator.refresh === "function") {
					validator.refresh();
				}
				return;
			}
			const vin = String(terms[0]?.vin || "").trim().toUpperCase();
			if (vin.length === 17) return;
			const bt = (terms[0]?.bodyType || "").trim();
			if (!bt) return;
			const radio = document.querySelector(
				'#fitment-questions-root .fitment-radio[value="' + bt + '"]',
			);
			if (radio && !radio.checked && !radio.disabled) {
				radio.checked = true;
				radio.dispatchEvent(new Event("change", { bubbles: true }));
				console.log("[Partify] Auto-selected body type:", bt);
				``;
			}
		} catch (e) {}
	}

	function waitForBodyTypeRadiosAndSelect() {
		var attempts = 0;
		var maxAttempts = 50; // 50 * 100ms = 5 seconds max

		var interval = setInterval(function () {
			attempts++;
			var root = document.getElementById("fitment-questions-root");
			var radios = root
				? Array.from(root.querySelectorAll(".fitment-radio"))
				: [];
			var ready = radios.some(function (r) {
				return r.value && r.value.trim() !== "";
			});

			if (ready) {
				clearInterval(interval);
				autoSelectBodyType();
			} else if (attempts >= maxAttempts) {
				clearInterval(interval);
			}
		}, 100);
	}

	// ─── FEATURE 4A: Price deltas on labels ────────────────────────────────────

	function priceInCents(value) {
		const amount = String(value ?? "").replace(/[$,\s]/g, "");
		if (!amount) return null;
		const price = Number(amount);
		return Number.isFinite(price) && price >= 0 ? Math.round(price * 100) : null;
	}

	function qualityVariants(radio) {
		const value = String(radio?.value || "").toLowerCase();
		const key = ["aftermarket", "capa", "oem"].find(function (quality) {
			return value.includes(quality);
		});
		return window.productVariants?.[key] || [];
	}

	function paintPriceTitle(value) {
		const title = String(value || "").trim().toLowerCase();
		if (title === "sin pintar") return "unpainted";
		return isMatchByVinCode(title) ? "match paint by vin" : title;
	}

	function selectedQualityPaintTitle(checked) {
		const select = document.getElementById("variant-selector");
		const paintRadio = document.querySelector(PAINT_RADIO_SEL + ":checked");
		if (!select || paintRadio?.id === UNPAINTED_ID) return null;
		if (!paintRadio && document.querySelector(PAINT_RADIO_SEL)) return "";

		const option = select.options[select.selectedIndex];
		const variants = qualityVariants(checked);
		const variant = variants.find(function (item) {
			return String(item.id) === select.value;
		});
		const title = paintPriceTitle(variant?.variantTitle || option?.dataset.variantTitle);
		const paintRequested = paintRadio && paintRadio.id !== UNPAINTED_ID;
		if (!paintRequested && (!title || title === "unpainted")) return null;
		if (select.disabled || !option?.value || option.disabled || !variant || !title || title === "unpainted") {
			return "";
		}
		return title;
	}

	function qualityPriceInCents(radio, paintTitle) {
		if (paintTitle === null) return priceInCents(radio.dataset.price);
		if (!paintTitle) return null;
		const variant = qualityVariants(radio).find(function (item) {
			return paintPriceTitle(item.variantTitle) === paintTitle;
		});
		return priceInCents(variant?.price);
	}

	function applyQualityDeltas() {
		const radios = Array.from(document.querySelectorAll(QUALITY_RADIO_SEL));
		if (!radios.length) return;

		const checked = document.querySelector(QUALITY_RADIO_SEL + ":checked");
		const selectedPaintTitle = selectedQualityPaintTitle(checked);
		const paintTitle = selectedPaintTitle === "" ? null : selectedPaintTitle;
		const prices = radios.map(function (radio) {
			return radio.disabled || radio.dataset.available === "false"
				? null
				: qualityPriceInCents(radio, paintTitle);
		});
		const availablePrices = prices.filter(function (price) { return price !== null; });
		const basePrice = checked
			? prices[radios.indexOf(checked)]
			: availablePrices.length ? Math.min(...availablePrices) : null;

		const container = document.getElementById("quality-type-select");
		if (container) {
			let note = container.querySelector('[data-quality-price-context]');
			if (!note) {
				note = document.createElement('p');
				note.dataset.qualityPriceContext = '';
				note.className = 'quality-price-context';
				container.appendChild(note);
			}
			note.textContent = container.dataset.basePriceNote || 'Unpainted price differences. Select a paint option to compare painted totals.';
			note.hidden = selectedPaintTitle !== "" || basePrice === null || availablePrices.length < 2;
		}

		radios.forEach(function (r, index) {
			const label = r.closest("label");
			if (!label) return;
			const existing = label.querySelector(".partify-delta");
			if (existing) existing.remove();
			label.querySelector(".partify-quality-starting-price")?.remove();
			if (r.disabled || r.dataset.available === "false") return;

			// Collect only DIRECT text node children of the label (not nested in spans).
			// The Liquid template renders name and price as two separate direct text nodes.
			const directTextNodes = Array.from(label.childNodes).filter(function (n) {
				return n.nodeType === Node.TEXT_NODE && n.textContent.trim();
			});

			// Cache the clean quality name from the FIRST direct text node (name only)
			if (!r.dataset.croLabel && directTextNodes.length) {
				r.dataset.croLabel = directTextNodes[0].textContent
					.trim()
					.replace(/\$[\d,.]+/, "") // strip price
					.replace(/\s*-+\s*$/, "") // strip trailing " -" separator
					.replace(/\s+/g, " ")
					.trim();
			}

			const name = r.dataset.croLabel || "";
			const isSelected = checked && r === checked;

			// Rewrite first direct text node to just the name; blank all others (price node)
			directTextNodes.forEach(function (n, i) {
				n.textContent = i === 0 ? " " + name + " " : "";
			});

			if (basePrice === null || prices[index] === null) return;
			const delta = prices[index] - basePrice;
			if (isSelected || delta === 0) return;

			// Build delta span
			const span = document.createElement("span");
			span.textContent = formatDelta(delta / 100);
			span.className =
				"partify-delta " +
				(delta > 0 ? "partify-delta--up" : "partify-delta--down");
			span.style.color = delta > 0 ? "#15803d" : "#dc2626";

			label.appendChild(span);
		});
	}

	function applyPaintDeltas() {
		const select = document.getElementById("variant-selector");
		if (!select) return;

		const opts = Array.from(select.options).filter(function (o) {
			return o.value;
		});

		// Fresh base = Unpainted option price for the now-selected quality tier
		let basePrice = null;
		opts.forEach(function (o) {
			if ((o.dataset.variantTitle || "").toLowerCase().includes("unpainted")) {
				basePrice = parseFloat((o.dataset.price || "0").replace(/,/g, ""));
			}
		});
		if (basePrice === null) return;

		opts.forEach(function (opt) {
			const title = opt.dataset.variantTitle || "";
			const price = parseFloat((opt.dataset.price || "0").replace(/,/g, ""));
			const delta = price - basePrice;
			opt.textContent = delta !== 0 ? title + " " + formatDelta(delta) : title;
		});
	}

	function applyPaintRadioDeltas() {
		const select = document.getElementById("variant-selector");
		if (!select) return;

		const opts = Array.from(select.options).filter(function (o) {
			return o.value;
		});

		// Resolve price for each radio from the dropdown
		let unpaintedPrice = null;
		opts.forEach(function (o) {
			if ((o.dataset.variantTitle || "").toLowerCase().includes("unpainted")) {
				unpaintedPrice = parseFloat((o.dataset.price || "0").replace(/,/g, ""));
			}
		});

		const storedOption = document.getElementById("paint-code-stored-option");
		let storedPrice = null;
		if (storedOption && storedOption.style.display !== "none") {
			const storedText = storedOption.querySelector(".checkbox-stored-code");
			const code = (storedText ? storedText.textContent : "").trim().toLowerCase().replace(/^painted\s+/i, "");
			opts.forEach(function (o) {
				const title = (o.dataset.variantTitle || "").toLowerCase();
				if (title.includes("unpainted")) return;
				if (code && title.includes(code)) {
					storedPrice = parseFloat((o.dataset.price || "0").replace(/,/g, ""));
				} else if (storedPrice === null) {
					storedPrice = parseFloat((o.dataset.price || "0").replace(/,/g, ""));
				}
			});
		}

		let selectCodePrice = null;
		if (select.value) {
			const sel = select.options[select.selectedIndex];
			if (sel && sel.dataset.price) selectCodePrice = parseFloat(sel.dataset.price.replace(/,/g, ""));
		}

		// Base = selected radio's price; fallback to Unpainted
		const checkedRadio = document.querySelector('input[name="select_paint_option"]:checked');
		let basePrice = unpaintedPrice;
		if (checkedRadio) {
			if (checkedRadio.id === "checkbox-paint-code-local-storage" && storedPrice !== null) {
				basePrice = storedPrice;
			} else if (checkedRadio.id === "checkbox-select-paint-option" && selectCodePrice !== null) {
				basePrice = selectCodePrice;
			} else if (checkedRadio.id === "checkbox-select-unpainted" && unpaintedPrice !== null) {
				basePrice = unpaintedPrice;
			}
		}
		if (basePrice === null) return;

		function setBadge(labelEl, price) {
			const existing = labelEl.querySelector(".partify-delta");
			if (existing) existing.remove();
			if (price === null) return;
			const delta = price - basePrice;
			if (Math.abs(delta) < 0.005) return;
			const span = document.createElement("span");
			span.textContent = formatDelta(delta);
			span.className = "partify-delta " + (delta > 0 ? "partify-delta--up" : "partify-delta--down");
			span.style.color = delta > 0 ? "#15803d" : "#dc2626";
			span.style.marginLeft = "4px";
			span.style.fontSize = "0.9em";
			labelEl.appendChild(span);
		}

		const unpaintedLabel = document.getElementById("unpainted-option");
		if (unpaintedLabel) setBadge(unpaintedLabel, unpaintedPrice);

		if (storedOption && storedOption.style.display !== "none") {
			setBadge(storedOption, storedPrice);
		} else if (storedOption) {
			const ex = storedOption.querySelector(".partify-delta");
			if (ex) ex.remove();
		}

		const selectCodeOption = document.getElementById("paint-code-select-code-option");
		if (selectCodeOption && getComputedStyle(selectCodeOption).display !== "none") {
			setBadge(selectCodeOption, selectCodePrice);
		}
	}

	// ─── FEATURE 4B: Desktop sticky ATC bar ──────────────────────────────────

	function initStickyBar() {
		// The script can be registered by both the global theme and older PDP markup.
		// Keep initialization idempotent so section reloads cannot duplicate IDs.
		if (document.getElementById("partify-sticky")) return;
		const mainAtcBtn =
			document.querySelector(MAIN_ATC_SEL) ||
			document.querySelector(".add-to-cart-for-unpainted");
		if (!mainAtcBtn) return;

		// ── Build the bar DOM ────────────────────────────────────────────────

		const bar = document.createElement("div");
		bar.id = "partify-sticky";
		bar.innerHTML =
			'<div class="ps-inner">' +
			'<img class="ps-thumb" src="" alt="">' +
			'<div class="ps-info">' +
			'<div class="ps-title"></div>' +
			'<div class="ps-pills">' +
			'<span class="ps-pill ps-pill--pending" id="pill-side"></span>' +
			'<span class="ps-pill ps-pill--pending" id="pill-quality"></span>' +
			'<span class="ps-pill ps-pill--pending" id="pill-paint"></span>' +
			"</div>" +
			"</div>" +
			'<div class="ps-price-col">' +
			'<div class="ps-price" id="partify-sticky-price"></div>' +
			'<div class="ps-shipping">Calculated at checkout</div>' +
			"</div>" +
			'<div class="ps-atc-col">' +
			'<button class="ps-atc-btn" id="partify-sticky-btn" disabled>Add to Cart</button>' +
			'<div class="ps-delivery" id="ps-delivery"></div>' +
			"</div>" +
			"</div>";
		document.body.appendChild(bar);

		// ── Inject styles ────────────────────────────────────────────────────

		const style = document.createElement("style");
		style.textContent =
			"#partify-sticky{" +
			"display:block;position:sticky;bottom:0;left:0;right:0;z-index:100;" +
			"background:#fff;border-top:1px solid #e5e7eb;" +
			"padding:12px 24px;" +
			"}" +
			"#partify-sticky.is-visible{display:block;}" +
			"@media(min-width:769px){.conditional-small-screen{display:none!important;}}" +
			"@media(max-width:768px){#partify-sticky{display:none!important;}}" +
			".ps-inner{" +
			"max-width:1200px;margin:0 auto;display:flex;align-items:center;gap:20px;" +
			"}" +
			".ps-thumb{" +
			"width:52px;height:52px;border-radius:8px;object-fit:contain;" +
			"background:#f9fafb;border:1px solid #e5e7eb;flex-shrink:0;" +
			"}" +
			".ps-info{flex:1;min-width:0;}" +
			".ps-title{" +
			"font-weight:700;font-size:14px;color:#111;" +
			"white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:360px;" +
			"}" +
			".ps-pills{display:flex;gap:6px;margin-top:4px;flex-wrap:wrap;}" +
			".ps-pill{" +
			"display:inline-block;padding:2px 10px;border-radius:999px;font-size:12px;font-weight:600;" +
			"border:1px solid #e5e7eb;color:#6b7280;background:#f9fafb;" +
			"}" +
			".ps-pill--done{background:#eef2ff;color:#0c1a94;border-color:#c7d2fe;}" +
			".ps-price-col{text-align:right;flex-shrink:0;min-width:120px;}" +
			".ps-price{font-weight:800;font-size:24px;color:#111;}" +
			".ps-shipping{font-size:12px;color:#6b7280;margin-top:2px;}" +
			".ps-atc-col{flex-shrink:0;text-align:center;}" +
			".ps-atc-btn{" +
			"background:#0c1a94;color:#fff;border:none;border-radius:12px;" +
			"padding:14px 36px;font-size:17px;font-weight:700;cursor:pointer;" +
			"transition:background .2s;white-space:nowrap;" +
			"}" +
			".ps-atc-btn:hover:not(:disabled){background:#063175;}" +
			".ps-atc-btn:disabled{background:#e5e7eb;color:#9ca3af;cursor:not-allowed;}" +
			".ps-atc-btn.is-added{background:#16a34a;}" +
			".ps-delivery{font-size:11px;color:#16a34a;font-weight:600;margin-top:3px;min-height:14px;}";
		document.head.appendChild(style);

		// ── References ───────────────────────────────────────────────────────

		const stickyBtn = document.getElementById("partify-sticky-btn");
		const stickyPrice = document.getElementById("partify-sticky-price");
		const pillSide = document.getElementById("pill-side");
		const pillQuality = document.getElementById("pill-quality");
		const pillPaint = document.getElementById("pill-paint");
		const deliveryEl = document.getElementById("ps-delivery");
		const thumbEl = bar.querySelector(".ps-thumb");
		const titleEl = bar.querySelector(".ps-title");
		const variantSelect = document.getElementById("variant-selector");

		// ── Populate static data (image + title) ─────────────────────────────

		const galleryImg = document.querySelector(".product-gallery--media img");
		if (galleryImg) {
			thumbEl.src = galleryImg.currentSrc || galleryImg.src;
			thumbEl.alt = galleryImg.alt || "";
		}
		const titleSource = document.getElementById("product-title");
		if (titleSource) titleEl.textContent = titleSource.textContent.trim();

		const BTN_TEXT = "Add to Cart";

		bar.classList.add("is-visible");

		// ── MutationObserver: mirror disabled state ──────────────────────────

		const mo = new MutationObserver(function () {
			stickyBtn.disabled = mainAtcBtn.disabled;
		});
		mo.observe(mainAtcBtn, { attributes: true, attributeFilter: ["disabled"] });

		// ── Pill helper ──────────────────────────────────────────────────────

		function setPill(pill, text, done) {
			if (!pill) return;
			if (!text) {
				pill.style.display = "none";
				return;
			}
			pill.style.display = "";
			pill.textContent = text;
			if (done) {
				pill.classList.remove("ps-pill--pending");
				pill.classList.add("ps-pill--done");
			} else {
				pill.classList.remove("ps-pill--done");
				pill.classList.add("ps-pill--pending");
			}
		}

		// ── Sync function ────────────────────────────────────────────────────

		// Debounce: coalesce rapid-fire calls that arrive within 80ms of each other.
		// 80ms catches double-dispatches from kit-bundle.liquid async re-renders and
		// quality change cascade (change → rAF → paint select → another change).
		let _syncTimer = null;
		function scheduleSyncStickyBar() {
			clearTimeout(_syncTimer);
			_syncTimer = setTimeout(function () {
				_syncTimer = null;
				syncStickyBar();
			}, 80);
		}

		function syncStickyBar() {
			// Side pill (from fitment radios)
			const sideRadio = document.querySelector(FITMENT_RADIO_SEL + ":checked");
			if (sideRadio) {
				setPill(pillSide, sideRadio.value, true);
			} else {
				const hasFitment = document.querySelector(FITMENT_RADIO_SEL);
				setPill(pillSide, hasFitment ? "Side" : "", !hasFitment);
			}

			// Quality pill
			const qRadio = document.querySelector(QUALITY_RADIO_SEL + ":checked");
			if (qRadio) {
				setPill(
					pillQuality,
					qRadio.dataset.croLabel || getSelectedQualityLabel(),
					true,
				);
			} else {
				setPill(pillQuality, "Quality", false);
			}

			// Paint pill
			const pRadio = document.querySelector(PAINT_RADIO_SEL + ":checked");
			if (pRadio) {
				setPill(pillPaint, getSelectedPaintLabel(), true);
			} else {
				const hasPaint = document.querySelector(PAINT_RADIO_SEL);
				setPill(pillPaint, hasPaint ? "Paint" : "", !hasPaint);
			}

			// Price — kit-bundle.liquid writes the assembly total to #bundle-total-value.
			// calculatePrice also overwrites #price-display-sticky with quality-only price,
			// so we read bundle-total-value (kit-exclusive) to get the correct kit total.
			if (stickyPrice) {
				const kitChecked = document.querySelector(
					'input[name="bundle_mode"][value="kit"]:checked',
				);
				const mainPrice = kitChecked
					? document.getElementById("bundle-total-value") ||
						document.getElementById("price-display-a2c") ||
						document.getElementById("price-display")
					: document.getElementById("price-display-a2c") ||
						document.getElementById("price-display");
				stickyPrice.textContent = mainPrice ? mainPrice.textContent.trim() : "";
			}

			stickyBtn.disabled = mainAtcBtn.disabled;
		}

		// ── Sticky button click ──────────────────────────────────────────────

		stickyBtn.addEventListener("click", function () {
			if (stickyBtn.disabled) return;
			// Delegate to the main form submit
			mainAtcBtn.click();
		});

		// ── Initial sync + live updates ──────────────────────────────────────

		syncStickyBar();

		// Only re-sync on inputs that actually affect price/pills.
		// Ignores fitment-inclusion, country-origin, and other unrelated inputs
		// that fire change events in loops and cause constant unnecessary re-renders.
		const STICKY_RELEVANT_SELS = [
			'input[name="quality_type"]',
			'input[name="bundle_mode"]',
			'input[name="select_paint_option"]',
			"#variant-selector",
			".fitment-radio",
		];
		document.addEventListener("change", function (e) {
			if (!e.target) return;
			const t = e.target;
			// Inclusion/exclusion origin-filter radios share .fitment-radio but fire in
			// tight loops on vehicle change — skip by both name AND id since either may
			// carry the pattern depending on how the input is rendered
			const nameOrId = (t.name || "") + " " + (t.id || "");
			if (nameOrId.includes("inclusion") || nameOrId.includes("exclusion"))
				return;
			const relevant = STICKY_RELEVANT_SELS.some(function (sel) {
				return t.matches(sel);
			});
			if (!relevant) return;
			scheduleSyncStickyBar();
		});

		// Catch price updates that happen outside of change events.
		// Observe price-display (calculatePrice writes quality-only price here)
		// and bundle-total-value (kit-bundle.liquid writes assembly total here).
		// Guard both with a content-change check so repeated writes of the same
		// value don't cascade into multiple syncStickyBar calls.
		const priceTarget = document.getElementById("price-display");
		if (priceTarget) {
			let _lastBasePrice = null;
			new MutationObserver(function () {
				const now = priceTarget.textContent.trim();
				if (now === _lastBasePrice) return;
				_lastBasePrice = now;
				scheduleSyncStickyBar();
			}).observe(priceTarget, {
				childList: true,
				characterData: true,
				subtree: true,
			});
		}
		const kitPriceTarget = document.getElementById("bundle-total-value");
		if (kitPriceTarget) {
			let _lastKitPrice = null;
			new MutationObserver(function () {
				const now = kitPriceTarget.textContent.trim();
				if (now === _lastKitPrice) return;
				_lastKitPrice = now;
				scheduleSyncStickyBar();
			}).observe(kitPriceTarget, {
				childList: true,
				characterData: true,
				subtree: true,
			});
		}

	}

	// ─── INIT ──────────────────────────────────────────────────────────────────

	// Primary hook: variantsUpdated fires from populateVariantDropdown after options are in the DOM
	document.addEventListener("variantsUpdated", function () {
		autoSelectZR2Paint();
	});

	function initPaintVariantGuard() {
		var savedPaintedVariant = null;

		window.addEventListener("pageshow", function (e) {
			if (e.persisted) window.location.reload();
		});

		// Save the painted variant the moment user picks a non-unpainted option
		document.addEventListener("change", function (e) {
			if (!e.target) return;

			// Quality changed — reset saved variant
			if (e.target.name === "quality_type") {
				savedPaintedVariant = null;
				return;
			}

			// User picked "Select Paint Code" radio or variant dropdown changed
			if (
				e.target.id === "checkbox-select-paint-option" ||
				e.target.id === "variant-selector"
			) {
				var vs = document.getElementById("variant-selector");
				if (vs && vs.value) {
					savedPaintedVariant = vs.value;
					console.log(
						"[Partify Guard] Saved painted variant:",
						savedPaintedVariant,
					);
				}
			}
		});

		// Reset on vehicle change
		document.addEventListener("partify:searchterms-changed", function () {
			savedPaintedVariant = null;
		});

		// Intercept every fetch — force correct variant into /cart/add calls
		var _origFetch = window.fetch;
		window.fetch = function (url, options) {
			if (
				!window.__paintGuardEnforcedId &&
				savedPaintedVariant &&
				typeof url === "string" &&
				url.includes("/cart/add")
			) {
				// Fix ID in URL query string (handles /cart/add?id=WRONG_ID)
				if (url.includes("id=") && !url.includes("id=" + savedPaintedVariant)) {
					url = url.replace(/([?&])id=[^&]*/g, "$1id=" + savedPaintedVariant);
					console.log("[Partify Guard] Correcting URL-based cart/add to:", url);
				}
				// Fix ID in FormData body
				if (options && options.body instanceof FormData) {
					var currentId = options.body.get("id");
					if (currentId && currentId !== savedPaintedVariant) {
						options.body.set("id", savedPaintedVariant);
						console.log(
							"[Partify Guard] Correcting FormData cart/add:",
							currentId,
							"->",
							savedPaintedVariant,
						);
					}
				}
				// Fix ID in string body
				if (
					options &&
					typeof options.body === "string" &&
					options.body.includes("id=")
				) {
					options.body = options.body.replace(
						/([?&]?)id=[^&]*/g,
						"$1id=" + savedPaintedVariant,
					);
					console.log("[Partify Guard] Correcting string body cart/add");
				}
			}
			return _origFetch.call(this, url, options);
		};

		// Also guard native form submit path
		document.addEventListener(
			"submit",
			function (e) {
				if (window.__paintGuardEnforcedId) return;
				if (!savedPaintedVariant) return;
				var form = e.target;
				var idInput = form.querySelector('[name="id"]');
				if (idInput && idInput.value !== savedPaintedVariant) {
					console.log(
						"[Partify Guard] Correcting variant on form submit:",
						idInput.value,
						"->",
						savedPaintedVariant,
					);
					idInput.value = savedPaintedVariant;
				}
			},
			true,
		);

		// Override productForm.submit() directly — native form.submit() bypasses
		// window.fetch AND submit event listeners entirely. This is why previous
		// fixes failed — the "Yes, Add Anyway" path calls form.submit() natively.
		setTimeout(function () {
			var productForm =
				document.getElementById("product-form") ||
				document.querySelector('form[action*="/cart/add"]');
			if (!productForm) return;

			var _origFormSubmit = HTMLFormElement.prototype.submit.bind(productForm);
			productForm.submit = function () {
				if (
					typeof window.__pdpFitmentGateHasSideHardStop === "function" &&
					window.__pdpFitmentGateHasSideHardStop()
				) {
					if (typeof window.__pdpFitmentGateRequestResolution === "function") {
						window.__pdpFitmentGateRequestResolution();
					}
					return;
				}
				if (savedPaintedVariant && !window.__paintGuardEnforcedId) {
					// Disable existing [name="id"] inputs (setting .value on SELECT silently fails)
					var idInputs = productForm.querySelectorAll('[name="id"]');
					idInputs.forEach(function (el) {
						el.disabled = true;
					});

					// Inject a guaranteed hidden input with the correct painted variant
					var guard = document.createElement("input");
					guard.type = "hidden";
					guard.name = "id";
					guard.value = savedPaintedVariant;
					productForm.appendChild(guard);

					console.log(
						"[Partify Guard] Forcing painted variant via hidden input:",
						savedPaintedVariant,
					);
					// Fix the form action URL if ID is baked in
					var action = productForm.getAttribute("action") || "";
					if (action.includes("id=")) {
						productForm.setAttribute(
							"action",
							action.replace(/([?&])id=[^&]*/g, "$1id=" + savedPaintedVariant),
						);
						console.log("[Partify Guard] Fixed form action URL");
					}
				}

				if (typeof window.__partifyBuildGuardedMainCartItem === "function") {
					const finalIdInput = Array.from(productForm.querySelectorAll('[name="id"]'))
						.find(function (input) { return !input.disabled && input.value; });
					const finalVariantId = savedPaintedVariant && !window.__paintGuardEnforcedId
						? savedPaintedVariant
						: finalIdInput && finalIdInput.value;
					const mainItemVerdict = window.__partifyBuildGuardedMainCartItem({
						form: productForm,
						variantId: finalVariantId,
					});
					if (!mainItemVerdict || !mainItemVerdict.ok) return;

					if (mainItemVerdict.requiresVin && mainItemVerdict.item.properties.VIN) {
						let canonicalVin = productForm.querySelector('input[type="hidden"][name="properties[VIN]"]');
						if (!canonicalVin) {
							canonicalVin = document.createElement("input");
							canonicalVin.type = "hidden";
							canonicalVin.name = "properties[VIN]";
							productForm.appendChild(canonicalVin);
						}
						canonicalVin.value = mainItemVerdict.item.properties.VIN;
					}
				}
				_origFormSubmit();
			};
			console.log("[Partify Guard] form.submit() intercepted");
		}, 500);

		// Intercept the CHANGE EVENT on unpainted radio (not .click())
		// initPaintOptionDefaults uses: unpaintedInput.checked = true; dispatchEvent(change)
		// Capture phase fires BEFORE syncProductFormVariantId can rewrite form.action
		var unpainted = document.getElementById("checkbox-select-unpainted");
		if (unpainted) {
			unpainted.addEventListener(
				"change",
				function (e) {
					if (savedPaintedVariant) {
						// Only block programmatic changes (e.g. initPaintOptionDefaults dispatchEvent).
						// A real user click (e.isTrusted) should clear the guard and allow Unpainted.
						if (e.isTrusted) {
							savedPaintedVariant = null;
							return;
						}
						e.stopImmediatePropagation();
						unpainted.checked = false;
						var paintRadio = document.getElementById(
							"checkbox-select-paint-option",
						);
						if (paintRadio) paintRadio.checked = true;
						console.log(
							"[Partify Guard] Intercepted unpainted change, variant preserved:",
							savedPaintedVariant,
						);
					}
				},
				true,
			);
		}
	}

	document.addEventListener("DOMContentLoaded", function () {
		// These run on ALL product pages regardless of whether paint variants exist
		applyQualityDeltas(); // Feature 4A — quality deltas
		autoSelectQuality(); // Feature 1
		autoSelectAssembly(); // Feature 3
		waitForBodyTypeRadiosAndSelect(); // Feature 5
		// Feature 1B — re-select cheapest quality when fitment/side changes
		document.addEventListener("change", function (e) {
			if (e.target.matches && e.target.matches(FITMENT_RADIO_SEL)) {
				// Fitment change triggers enableProductTypeSelect → initQualityOptionDefaults
				// which respects existing selections. Force cheapest after a brief settle.
				setTimeout(forceSelectPreferredQuality, 300);
			}
		});

		// Re-apply deltas whenever quality selection changes
		document.addEventListener("change", function (e) {
			if (e.target.matches && e.target.matches(QUALITY_RADIO_SEL)) {
				applyQualityDeltas(); // Recalculate deltas relative to new selection
				// populateVariantDropdown is async — wait for it to settle
				requestAnimationFrame(function () {
					requestAnimationFrame(function () {
						requestAnimationFrame(function () {
							autoSelectPaint(); // Feature 2
							applyQualityDeltas();
							applyPaintDeltas(); // Feature 4A — paint deltas
							applyPaintRadioDeltas();
						});
					});
				});
			}
		});

		// On a normal PDP load (vehicle already in the garage) the auto-select
		// path's 500ms enableAddToCartButton() never runs. Fix: listen for fitment
		// success and enable ATC after all auto-selections settle.
		document.addEventListener("partify:native-fitment-resolved", function (e) {
			if ((e.detail || {}).state !== "success") return;
			setTimeout(function () {
				// Don't enable ATC if submodel is required but the saved vehicle has none.
				if (window.partifySubmodelRequired) {
					const _pfcState = document
						.querySelector("[data-partify-fitment-card]")
						?.getAttribute("data-pfc-state");
					if (_pfcState === "warn-submodel") return;
				}
				// If unpainted is checked but variant selector still has no value,
				// the paint handler early-returned (options[1] was missing when it fired)
				// because populateVariantDropdown() hadn't run yet. Re-fire the change
				// event now that options are present — same pattern as __partifyCroAutoSelect.
				const _unpainted = document.getElementById("checkbox-select-unpainted");
				const _variantSel = document.getElementById("variant-selector");
				if (
					_unpainted &&
					_unpainted.checked &&
					_variantSel &&
					!_variantSel.disabled &&
					!_variantSel.value &&
					_variantSel.options.length > 1
				) {
					_unpainted.dispatchEvent(new Event("change", { bubbles: true }));
					return; // paint handler calls enableAddToCartButton() itself
				}
				if (typeof enableAddToCartButton === "function")
					enableAddToCartButton();
				if (typeof updateProgressHeaderColors === "function")
					updateProgressHeaderColors();
			}, 600);
		});

		// Paint/ZR2/sticky only apply when a variant selector exists
		if (!document.getElementById("variant-selector")) return;

		initStickyBar(); // Feature 4B

		// Re-apply paint deltas and check ZR2 whenever variant-selector options are rebuilt
		const _vs = document.getElementById("variant-selector");
		new MutationObserver(function () {
			applyPaintDeltas();
			applyPaintRadioDeltas();
			autoSelectZR2Paint();
			applyQualityDeltas();
		}).observe(_vs, { childList: true });

		const priceDisplay = document.getElementById("price-display");
		if (priceDisplay) {
			new MutationObserver(applyQualityDeltas).observe(priceDisplay, {
				childList: true,
				characterData: true,
				subtree: true,
			});
		}

		// ZR2 fallback: if dropdown was already populated before the observer registered, run now
		setTimeout(function () {
			autoSelectZR2Paint();
		}, 300);

		// Update radio deltas when paint code dropdown changes or paint radio selection changes
		_vs.addEventListener("change", function () {
			applyPaintRadioDeltas();
			applyQualityDeltas();
		});
		document.addEventListener("change", function (e) {
			if (e.target.matches && e.target.matches('input[name="select_paint_option"]')) {
				applyPaintRadioDeltas();
				applyQualityDeltas();
			}
		});

		// Update stored-code radio delta when it becomes visible (VIN/plate decode)
		const _storedOpt = document.getElementById("paint-code-stored-option");
		if (_storedOpt) {
			new MutationObserver(function () {
				applyPaintRadioDeltas();
				applyQualityDeltas();
			}).observe(_storedOpt, { attributes: true, attributeFilter: ["style"] });
		}

		// Also try paint auto-select immediately — for cases where global-library.js
		// already handled quality + paint via handleInsertLocalStoragePaintOption()
		setTimeout(function () {
			autoSelectPaint();
		}, 500);

		initPaintVariantGuard();
	});

	window.__partifyCroAutoSelect = function () {
		if (typeof enableProductTypeSelect === "function")
			enableProductTypeSelect();
		if (typeof enableQualityDescriptionBtn === "function")
			enableQualityDescriptionBtn();
		if (typeof enablePaintOptionRadioBtns === "function")
			enablePaintOptionRadioBtns();
		if (typeof updateProgressHeaderColors === "function")
			updateProgressHeaderColors();
		autoSelectQuality();
		autoSelectAssembly();
		autoSelectPaint();
		setTimeout(function () {
			// If unpainted is checked but variant selector still has no value, populateVariantDropdown
			// ran after the unpainted handler had already early-returned (options[1] was missing).
			// Re-fire the change event now that variants are in the DOM.
			const _unpainted = document.getElementById("checkbox-select-unpainted");
			const _variantSel = document.getElementById("variant-selector");
			if (
				_unpainted &&
				_unpainted.checked &&
				_variantSel &&
				!_variantSel.disabled &&
				!_variantSel.value
			) {
				_unpainted.dispatchEvent(new Event("change", { bubbles: true }));
			}
			if (typeof enableAddToCartButton === "function") enableAddToCartButton();
			if (typeof updateProgressHeaderColors === "function")
				updateProgressHeaderColors();
		}, 500);
	};
})();

// VIN Entry Tracking – fires for ALL visitors (not gated behind A/B flag)
(function initVinEntryTracking() {
	var LOG = function () {
		var args = Array.prototype.slice.call(arguments);
		args.unshift("[VIN Tracking]");
		console.log.apply(console, args);
	};

	var fired = false;

	function fireEvent() {
		if (fired) return;
		fired = true;
		window.igEvents = window.igEvents || [];
		window.igEvents.push({ event: "vin_entered" });
		LOG("Fired vin_entered event to Intelligems");
	}

	function attachListeners(input) {
		LOG("Found VIN input:", input.id || input.name);
		function handler() {
			if (input.value && input.value.trim().length >= 5) {
				fireEvent();
			}
		}
		input.addEventListener("input", handler);
		input.addEventListener("change", handler);
		if (input.value && input.value.trim().length >= 5) {
			fireEvent();
		}
	}

	function findAndAttach() {
		var inputs = document.querySelectorAll(
			'input[data-vin-input], input[name*="VIN"], input[name*="vin"], input[id*="vin"]',
		);
		for (var i = 0; i < inputs.length; i++) {
			if (inputs[i].type === "text" || inputs[i].type === "search") {
				attachListeners(inputs[i]);
			}
		}
		return inputs.length > 0;
	}

	function init() {
		if (window.location.pathname.indexOf("/products/") !== 0) {
			LOG("Not a product page, skipping");
			return;
		}
		LOG("Initializing on", window.location.pathname);

		if (findAndAttach()) return;

		// Poll for dynamically rendered VIN inputs
		var attempts = 0;
		var interval = setInterval(function () {
			attempts++;
			if (findAndAttach() || attempts >= 60) {
				clearInterval(interval);
				if (attempts >= 60) LOG("Gave up polling for VIN input after 30s");
			}
		}, 500);
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
})();

/* =============================================================================
 * default-config A/B test  (prefix: DefaultConfig / suffix: _DEFCFG)
 * -----------------------------------------------------------------------------
 * Intervention ("default"): CAPA quality + Painted paint option.
 * Control ("main"): no intervention — current experience unchanged.
 *
 * KEY DESIGN: hooks the page's own `variantsUpdated` event (dispatched on
 * document after populateVariantDropdown resolves) instead of polling for
 * paint readiness. Listener attached BEFORE clicking quality so the sequence
 * is guaranteed by the page lifecycle, not a race.
 * ============================================================================= */
(function initDefaultConfigTest_DEFCFG() {
	"use strict";

	var SLUG_DEFCFG = "default-config";
	var IG_FLAG_DEFCFG = "__PARTIFY_DEFAULT_CONFIG";
	var LS_VARIANT_DEFCFG = "__onsite_test__default-config__variant";
	var LS_TOGGLE_DEFCFG = "__onsite_test__default-config";
	var POLL_MS_DEFCFG = 150;
	var DEADLINE_MS_DEFCFG = 5000;
	var LOG_DEFCFG = "[DefaultConfig]";

	function log_DEFCFG() {
		try {
			var a = Array.prototype.slice.call(arguments);
			a.unshift(LOG_DEFCFG);
			console.log.apply(console, a);
		} catch (e) {}
	}

	function track_DEFCFG(event, extra) {
		try {
			window.igEvents = window.igEvents || [];
			var payload = { event: event, test: SLUG_DEFCFG };
			if (extra)
				for (var k in extra) if (extra.hasOwnProperty(k)) payload[k] = extra[k];
			window.igEvents.push(payload);
		} catch (e) {}
	}

	/* ---- variant resolution ------------------------------------------------ */
	function readImmediateVariant_DEFCFG() {
		try {
			var v = localStorage.getItem(LS_VARIANT_DEFCFG);
			if (v === "default" || v === "main") {
				log_DEFCFG("localStorage override:", v);
				return v;
			}
			var t = localStorage.getItem(LS_TOGGLE_DEFCFG);
			if (t === "on") {
				log_DEFCFG("QA toggle: on -> default");
				return "default";
			}
			if (t === "off") {
				log_DEFCFG("QA toggle: off -> main");
				return "main";
			}
		} catch (e) {}
		return null;
	}

	function readIgFlag_DEFCFG() {
		var v = window[IG_FLAG_DEFCFG];
		if (v === "default" || v === "main") return v;
		return null;
	}

	function resolveVariant_DEFCFG(cb) {
		var immediate = readImmediateVariant_DEFCFG();
		if (immediate) {
			cb(immediate);
			return;
		}

		var flag = readIgFlag_DEFCFG();
		if (flag) {
			log_DEFCFG("Intelligems flag:", flag);
			cb(flag);
			return;
		}

		var waited = 0;
		var timer = setInterval(function () {
			var f = readIgFlag_DEFCFG();
			if (f) {
				clearInterval(timer);
				log_DEFCFG("Intelligems flag resolved after", waited, "ms:", f);
				cb(f);
				return;
			}
			waited += POLL_MS_DEFCFG;
			if (waited >= DEADLINE_MS_DEFCFG) {
				clearInterval(timer);
				log_DEFCFG("Intelligems timeout -> fallback main");
				cb("main");
			}
		}, POLL_MS_DEFCFG);
	}

	/* ---- on-file detection ------------------------------------------------- */
	function hasPaintInfoOnFile_DEFCFG() {
		try {
			var raw = localStorage.getItem("searchTerms");
			if (!raw) return false;
			var arr = JSON.parse(raw);
			if (!Array.isArray(arr) || !arr.length || !arr[0]) return false;
			var v = arr[0];
			return !!(v.vin || v.plate || v.paintCode);
		} catch (e) {}
		return false;
	}

	/* ---- quality selection: CAPA, else cheapest available ------------------- */
	function selectCapaOrCheapest_DEFCFG() {
		var radios = document.querySelectorAll('input[name="quality_type"]');
		if (!radios || !radios.length) return false;

		var enabled = [];
		for (var i = 0; i < radios.length; i++) {
			if (radios[i].disabled) continue;
			if (radios[i].getAttribute("data-available") === "false") continue;
			enabled.push(radios[i]);
		}
		if (!enabled.length) return false;

		var target = null;
		var which = "cheapest";
		for (var j = 0; j < enabled.length; j++) {
			if ((enabled[j].value || "").toLowerCase().indexOf("capa") !== -1) {
				target = enabled[j];
				which = "capa";
				break;
			}
		}
		if (!target) {
			var best = null,
				bestPrice = Infinity;
			for (var k = 0; k < enabled.length; k++) {
				var priceStr = enabled[k].getAttribute("data-price") || "";
				var n = parseFloat(priceStr.replace(/[^0-9.]/g, ""));
				if (!isNaN(n) && n < bestPrice) {
					bestPrice = n;
					best = enabled[k];
				}
			}
			target = best;
		}
		if (!target) return false;

		if (!target.checked) {
			target.click();
		}
		track_DEFCFG("default_config_quality_selected", { which: which });
		log_DEFCFG("Quality selected:", which, target.value);
		return true;
	}

	/* ---- paint selection --------------------------------------------------- */
	function selectPainted_DEFCFG() {
		// HAS VIN/LP on file → select the stored/decoded paint code radio
		if (hasPaintInfoOnFile_DEFCFG()) {
			var stored = document.getElementById("checkbox-paint-code-local-storage");
			if (
				stored &&
				!stored.disabled &&
				stored.parentElement &&
				stored.parentElement.style.display !== "none"
			) {
				if (!stored.checked) stored.click();
				track_DEFCFG("default_config_paint_selected", { mode: "stored_code" });
				log_DEFCFG("Stored paint code selected (VIN/LP on file).");
				return true;
			}
			// Stored radio not visible yet — might still be loading. Fall through to
			// select the VIN/license option so the decode flow triggers.
		}

		// NO info on file (or stored radio not ready) → select "Match Paint Code By License Plate | by VIN"
		var byPlate = document.getElementById(
			"checkbox-get-paint-code-with-license",
		);
		var byVin = document.getElementById("checkbox-get-paint-code-with-vin");
		var target =
			byPlate && !byPlate.disabled
				? byPlate
				: byVin && !byVin.disabled
					? byVin
					: null;
		if (target) {
			if (!target.checked) target.click();
			track_DEFCFG("default_config_paint_selected", {
				mode: "license_vin_prompt",
			});
			log_DEFCFG("Match by License/VIN selected.");
			return true;
		}

		// Fallback: if license/VIN options aren't available (excluded make), use Select Paint Code
		var selectPaint = document.getElementById("checkbox-select-paint-option");
		if (selectPaint && !selectPaint.disabled) {
			if (!selectPaint.checked) selectPaint.click();
			track_DEFCFG("default_config_paint_selected", {
				mode: "select_code_fallback",
			});
			log_DEFCFG("Select Paint Code fallback (no license/VIN option).");
			armAtcPrompt_DEFCFG();
			return true;
		}
		log_DEFCFG("Paint radios not available; no-op.");
		return false;
	}

	/* ---- ATC interception + prompt ----------------------------------------- */
	var atcArmed_DEFCFG = false;
	var atcSatisfied_DEFCFG = false;

	function isPaintedSelected_DEFCFG() {
		var unpainted = document.getElementById("checkbox-select-unpainted");
		if (unpainted && unpainted.checked) return false;
		var selectPaint = document.getElementById("checkbox-select-paint-option");
		var stored = document.getElementById("checkbox-paint-code-local-storage");
		var byVin = document.getElementById("checkbox-get-paint-code-with-vin");
		var byPlate = document.getElementById(
			"checkbox-get-paint-code-with-license",
		);
		return !!(
			(selectPaint && selectPaint.checked) ||
			(stored && stored.checked) ||
			(byVin && byVin.checked) ||
			(byPlate && byPlate.checked)
		);
	}

	function armAtcPrompt_DEFCFG() {
		if (atcArmed_DEFCFG) return;
		atcArmed_DEFCFG = true;

		document.addEventListener(
			"click",
			function (e) {
				if (atcSatisfied_DEFCFG) return;
				var btn =
					e.target && e.target.closest
						? e.target.closest(".add-to-cart, .add-to-cart-for-unpainted")
						: null;
				if (!btn) return;
				if (!isPaintedSelected_DEFCFG()) return;
				if (hasPaintInfoOnFile_DEFCFG()) return;
				e.preventDefault();
				e.stopImmediatePropagation();
				showPrompt_DEFCFG(btn);
			},
			true,
		);
	}

	function showPrompt_DEFCFG(triggerBtn) {
		if (document.getElementById("defcfg-paint-prompt")) return;
		track_DEFCFG("default_config_atc_prompt_shown");

		var overlay = document.createElement("div");
		overlay.id = "defcfg-paint-prompt";
		overlay.setAttribute("role", "dialog");
		overlay.setAttribute("aria-modal", "true");
		overlay.style.cssText =
			"position:fixed;inset:0;z-index:99999;display:flex;align-items:center;" +
			"justify-content:center;background:rgba(0,0,0,.5);padding:16px;";

		var box = document.createElement("div");
		box.style.cssText =
			"background:#fff;max-width:420px;width:100%;border-radius:12px;padding:24px;" +
			"font-family:inherit;box-shadow:0 10px 40px rgba(0,0,0,.25);";

		var h = document.createElement("h2");
		h.textContent = "How should we match your paint?";
		h.style.cssText = "margin:0 0 8px;font-size:18px;line-height:1.3;";

		var p = document.createElement("p");
		p.textContent =
			"Enter any one of these and we\u2019ll paint your part to match. Or choose unpainted instead.";
		p.style.cssText =
			"margin:0 0 16px;font-size:14px;color:#444;line-height:1.4;";

		var input = document.createElement("input");
		input.type = "text";
		input.id = "defcfg-paint-input";
		input.placeholder = "Paint code, license plate, or VIN";
		input.autocomplete = "off";
		input.style.cssText =
			"width:100%;box-sizing:border-box;padding:12px;font-size:15px;" +
			"border:1px solid #bbb;border-radius:8px;margin-bottom:6px;";

		var err = document.createElement("div");
		err.id = "defcfg-paint-err";
		err.style.cssText =
			"color:#c0392b;font-size:12px;min-height:16px;margin-bottom:12px;";

		var confirm = document.createElement("button");
		confirm.type = "button";
		confirm.textContent = "Add to cart with paint match";
		confirm.style.cssText =
			"width:100%;padding:13px;font-size:15px;font-weight:600;border:0;border-radius:8px;" +
			"background:#111;color:#fff;cursor:pointer;margin-bottom:10px;";

		var optOut = document.createElement("button");
		optOut.type = "button";
		optOut.textContent = "I want it unpainted instead";
		optOut.style.cssText =
			"width:100%;padding:11px;font-size:13px;border:0;border-radius:8px;" +
			"background:transparent;color:#555;cursor:pointer;text-decoration:underline;";

		box.appendChild(h);
		box.appendChild(p);
		box.appendChild(input);
		box.appendChild(err);
		box.appendChild(confirm);
		box.appendChild(optOut);
		overlay.appendChild(box);
		document.body.appendChild(overlay);
		setTimeout(function () {
			try {
				input.focus();
			} catch (e) {}
		}, 30);

		function classify(val) {
			var s = (val || "").trim();
			if (!s) return null;
			var alnum = s.replace(/[\s-]/g, "");
			if (/^[A-HJ-NPR-Z0-9]{17}$/i.test(alnum)) return "vin";
			if (alnum.length >= 5 && alnum.length <= 8) return "plate";
			return "code";
		}

		function close() {
			try {
				document.body.removeChild(overlay);
			} catch (e) {}
		}

		confirm.addEventListener("click", function () {
			var val = input.value;
			var type = classify(val);
			if (!type) {
				err.textContent = "Please enter a paint code, plate, or VIN.";
				return;
			}
			persistPaintInfo_DEFCFG(val, type);
			track_DEFCFG("default_config_paint_info_submitted", { type: type });
			atcSatisfied_DEFCFG = true;
			close();
			if (triggerBtn) triggerBtn.click();
		});

		optOut.addEventListener("click", function () {
			var unpainted = document.getElementById("checkbox-select-unpainted");
			if (unpainted) {
				unpainted.click();
				unpainted.dispatchEvent(new Event("change", { bubbles: true }));
			}
			track_DEFCFG("default_config_unpainted_opt_out");
			atcSatisfied_DEFCFG = true;
			close();
			if (triggerBtn) triggerBtn.click();
		});

		overlay.addEventListener("click", function (e) {
			if (e.target === overlay) close();
		});
	}

	function persistPaintInfo_DEFCFG(value, type) {
		try {
			var raw = localStorage.getItem("searchTerms");
			var arr = raw ? JSON.parse(raw) : [];
			if (!Array.isArray(arr)) arr = [];
			if (!arr.length) arr.push({});
			if (type === "vin") arr[0].vin = value;
			else if (type === "plate") arr[0].plate = value;
			else arr[0].paintCode = value;
			localStorage.setItem("searchTerms", JSON.stringify(arr));
		} catch (e) {}

		try {
			var form =
				document.querySelector('form[action^="/cart/add"]') ||
				document.getElementById("product-form");
			if (form) {
				var nameMap = {
					vin: "properties[VIN]",
					plate: "properties[Plate]",
					code: "properties[Paint Code]",
				};
				var propName = nameMap[type];
				var existing = form.querySelector('input[name="' + propName + '"]');
				if (!existing) {
					existing = document.createElement("input");
					existing.type = "hidden";
					existing.name = propName;
					form.appendChild(existing);
				}
				existing.value = value;
			}
		} catch (e) {}
	}

	/* ---- intervention orchestration (sequential poll) ---------------------- */
	function runIntervention_DEFCFG() {
		window.__paintDefaultTestPainted = true;
		window.__defaultConfigTestQuality = true;

		// Simple state machine: step through quality → paint using DOM state.
		// No event listeners, no race conditions. Just check what's true.
		var STEP_QUALITY = 1;
		var STEP_PAINT = 2;
		var STEP_DONE = 3;
		var step = STEP_QUALITY;
		var elapsed = 0;
		var TIMEOUT = 10000;

		var timer = setInterval(function () {
			elapsed += 200;
			if (elapsed > TIMEOUT) {
				clearInterval(timer);
				log_DEFCFG("Timed out at step", step);
				return;
			}

			if (step === STEP_QUALITY) {
				// Is a quality radio already checked?
				var checked = document.querySelector(
					'input[name="quality_type"]:checked',
				);
				if (checked && !checked.disabled) {
					// Quality is set — ensure it's CAPA if possible
					var val = (checked.value || "").toLowerCase();
					if (val.indexOf("capa") === -1) {
						selectCapaOrCheapest_DEFCFG();
					}
					log_DEFCFG("Quality done (was already checked).");
					step = STEP_PAINT;
					return;
				}
				// Try to select quality
				var radios = document.querySelectorAll(
					'input[name="quality_type"]:not([disabled])',
				);
				if (radios && radios.length) {
					selectCapaOrCheapest_DEFCFG();
					log_DEFCFG("Quality clicked.");
					step = STEP_PAINT;
				}
				return;
			}

			if (step === STEP_PAINT) {
				// Is a paint radio already checked (and not unpainted)?
				var paintChecked = document.querySelector(
					'input[name="select_paint_option"]:checked',
				);
				if (paintChecked && paintChecked.id !== "checkbox-select-unpainted") {
					log_DEFCFG("Paint already selected:", paintChecked.id);
					step = STEP_DONE;
					clearInterval(timer);
					return;
				}
				// Check if any paint radio is enabled — if so, run our selection logic
				var byPlate = document.getElementById(
					"checkbox-get-paint-code-with-license",
				);
				var byVin = document.getElementById("checkbox-get-paint-code-with-vin");
				var selectPaint = document.getElementById(
					"checkbox-select-paint-option",
				);
				var anyEnabled =
					(byPlate && !byPlate.disabled) ||
					(byVin && !byVin.disabled) ||
					(selectPaint && !selectPaint.disabled);
				if (anyEnabled) {
					selectPainted_DEFCFG();
					step = STEP_DONE;
					clearInterval(timer);
					return;
				}
			}
		}, 200);
	}

	/* ---- entry ------------------------------------------------------------- */
	// CRITICAL: Determine variant and set flags SYNCHRONOUSLY at parse time.
	// The main CRO IIFE's DOMContentLoaded handler calls autoSelectQuality() and
	// autoSelectPaint(). If our flags aren't set before DOMContentLoaded fires,
	// the page's defaults run first and our selections never apply.
	// Intelligems blocking script loads before DOMContentLoaded, and localStorage
	// is always available at parse time, so we can resolve immediately in most cases.
	var earlyVariant_DEFCFG =
		readImmediateVariant_DEFCFG() || readIgFlag_DEFCFG();
	if (earlyVariant_DEFCFG === "default") {
		window.__paintDefaultTestPainted = true;
		window.__defaultConfigTestQuality = true;
		log_DEFCFG("Flags set at parse time (early resolve).");
	}

	function start_DEFCFG() {
		resolveVariant_DEFCFG(function (variant) {
			track_DEFCFG("default_config_exposure", { variant: variant });
			if (variant !== "default") {
				log_DEFCFG("Control group (" + variant + ") — no intervention.");
				// If flags were optimistically set, unset them (shouldn't happen
				// since earlyVariant already matched, but safety).
				window.__paintDefaultTestPainted = false;
				window.__defaultConfigTestQuality = false;
				return;
			}
			log_DEFCFG("Intervention group — applying Painted + CAPA defaults.");
			runIntervention_DEFCFG();
		});
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", start_DEFCFG);
	} else {
		start_DEFCFG();
	}
})();
